import { useEffect, useState } from "react";
import {
  getPaginatedValidationDuplicateErrorsList,
  getPaginatedValidationDuplicateErrorsListWithoutIssue,
} from "../services/resourcesService";
import { validationDuplicateErrorsMockData } from "../services/constants/resource";

interface IuseFetchPaginatedValidationDuplicateErrors {
  currentValidationResultId: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  pSize: number;
  isDetailedExecutionDataAvailable: boolean;
  isIssuesDataAvailable: boolean;
  resourceId: any;
}

const useFetchPaginatedValidationDuplicateErrors = ({
  currentValidationResultId,
  setIsLoading,
  page,
  pSize,
  isDetailedExecutionDataAvailable,
  isIssuesDataAvailable,
  resourceId,
}: IuseFetchPaginatedValidationDuplicateErrors) => {
  const [duplicateValidationErrors, setduplicateValidationErrors] =
    useState<any>([]);
  useEffect(() => {
    const fetchValidationData = async () => {
      setIsLoading(true);
      try {
        let result;

        // Use conditional logic based on is_issues_data_available flag
        if (isIssuesDataAvailable) {
          // Use existing endpoint with issues
          result = await getPaginatedValidationDuplicateErrorsList({
            currentValidationResultId,
            resourceId,
            page,
            pSize,
          });
        } else {
          // Use new endpoint without issues
          result = await getPaginatedValidationDuplicateErrorsListWithoutIssue({
            currentValidationResultId,
            page,
            pSize,
          });
        }

        //Set Mock Data
        // const result: any = validationDuplicateErrorsMockData;

        setduplicateValidationErrors(result);
      } catch (err) {
        setduplicateValidationErrors([]);
      } finally {
        setIsLoading(false);
      }
    };
    if (!isDetailedExecutionDataAvailable) fetchValidationData();
  }, [
    currentValidationResultId,
    page,
    pSize,
    resourceId,
    isIssuesDataAvailable,
  ]);

  return [duplicateValidationErrors];
};

export default useFetchPaginatedValidationDuplicateErrors;
